import { AfterViewInit, Component, EventEmitter, ViewChild } from '@angular/core';
import { MzModalComponent } from 'ng2-materialize';

@Component({
  selector:    'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls:   [ './confirm.component.scss' ]
})
export class ConfirmComponent implements AfterViewInit {

  @ViewChild('confirmModal') modal: MzModalComponent;
  onConfirm: EventEmitter<boolean> = new EventEmitter();
  text: string;
  confirmed = false;
  modalOptions: Materialize.ModalOptions = {
    dismissible: false,
    complete:    () => {
      this.onConfirm.emit(this.confirmed);
    }
  };

  constructor() {
  }

  confirm() {
    this.confirmed = true;
    this.modal.close();
  }

  ngAfterViewInit() {
    this.modal.open();
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/services/prompt/confirm/confirm.component.ts